import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import type { Observable } from "rxjs";
import { map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import { rewardsAuthApiClientV3Token } from "../../../tokens";
import { RewardsB2bCompanyPointBalanceEntity } from "../models/RewardsB2bCompanyEntities";
import { RewardsB2bCompanyPointBalanceSchema } from "../models/RewardsB2bCompanySchemas";
import { RewardsB2bCompanyPointBalanceQueryParams } from "../types";

@singleton()
class RewardsB2bCompanyApiService {
    constructor(
        @inject(rewardsAuthApiClientV3Token)
        private readonly apiClientV3: ApiClientInterface
    ) {}

    getB2bCompanyPointBalance(
        queryParams: RewardsB2bCompanyPointBalanceQueryParams
    ): Observable<RewardsB2bCompanyPointBalanceEntity> {
        return this.apiClientV3
            .get({
                url: "/b2b/company/getPointBalance",
                queryParams,
                responseType: "json",
            })
            .pipe(
                map((value) =>
                    create(value.body, RewardsB2bCompanyPointBalanceSchema)
                )
            );
    }
}

export default RewardsB2bCompanyApiService;
